var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-main',[_c('router-view',{attrs:{"name":"menu"}}),(_vm.displayErrorPage)?[_c('Error',{attrs:{"error-code":_vm.errorCode}})]:[_c('router-view',{attrs:{"name":"main"}})]],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }